import gql from 'graphql-tag';
import { clients } from '../../util/clients';
import { fieldsToGqlString } from '../../util/shared/vue-global';

const { backend } = clients.direct;

const defaultFields = {
  importedData: '',
  totalRecords: '',
  importingStatus: '',
  isThereAnError: '',
};

export const importStatus = {
  namespaced: true,
  state: {
    selectedCollection: null,
  },
  mutations: {
    setSelectedCollection(state, collection) {
      state.selectedCollection = collection;
    },
    setSelectedScript(state, script) {
      state.selectedScript = script;
    },
  },
  actions: {
    async updateSelectedCollectionInStore({ commit }, collection) {
      commit('setSelectedCollection', collection);
    },
    async updateSelectedScriptInStore({ commit }, script) {
      commit('setSelectedScript', script);
    },
    async loadImportLargeFilesData({ dispatch }) {
      try {
        // const query = gql`query importStatus`;
        const { data } = await backend.query({
          query: gql`query importStatus {
            importStatus {
              ${fieldsToGqlString(defaultFields)},
            } 
          }`,
          fetchPolicy: 'no-cache',
        });
        if (data) {
          return data.importStatus;
        }
        dispatch('flashWarn', 'There was a problem while importing data.', { root: true });
      } catch (error) {
        dispatch('logException', error, { root: true });
        dispatch('flashError', 'There was a problem getting data.', { root: true });
        return 0;
      }
      return null;
    },
    async scriptGrossAssessedUpdate({ dispatch }, { criteria }) {
      try {
        // const query = gql`query importStatus`;
        const { data } = await backend.query({
          query: gql` query scriptGrossAssessed($criteria:grossAssessedInputType){
            scriptGrossAssessed(criteria: $criteria) {
            ok,
            nMatched,
              }
            }
          `,
          variables: { criteria },
        });
        if (data) {
          return data.scriptGrossAssessed;
        }
        dispatch('flashWarn', 'There was a problem while importing data.', { root: true });
      } catch (error) {
        dispatch('logException', error, { root: true });
        dispatch('flashError', 'There was a problem getting data.', { root: true });
        return 0;
      }
      return null;
    },
    async truncateTempCollection({ commit, dispatch }, { item }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation truncateTempCollection ($item:truncateInputType)  {
            truncateTempCollection(upsert: $item) {
                    status,
                    error,
                    acknowledged,
                    deletedCount
                  }
                }`,
          variables: {
            item,
          },
        });
        clients.handleGQLErrors(results, commit);
        const { status, deletedCount } = results.data.truncateTempCollection;

        if (status) {
          dispatch('flashSuccess', `${deletedCount} Records Deleted`, { root: true });
        }
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem in upserting the Tax Fees', { root: true });
      }
    },
    async LegacyImport({ commit, dispatch }, { criteria }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`
          query startImporting($criteria:truncateInputType){
            startImporting(criteria: $criteria) {
                status,
                error,
                message
              }
            }
          `,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });

        clients.handleGQLErrors(results, commit);
        const { message, status, error } = results.data.startImporting;
        if (status) {
          dispatch('flashSuccess', message, { root: true });
        } else {
          dispatch('flashError', error, { root: true });
        }
      } catch (error) {
        dispatch('flashError', 'There was a problem Importing file.', { root: true });
      }
    },
    async additionalScript({ commit, dispatch }, { criteria }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`
          query additionalScriptsSupportsLegacy($criteria:truncateInputType){
            additionalScriptsSupportsLegacy(criteria: $criteria) {
                status,
                error,
                message,
                count,
                rows
              }
            }
          `,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });

        clients.handleGQLErrors(results, commit);
        const scriptResults = results.data.additionalScriptsSupportsLegacy;
        const {
          message, status, error,
        } = scriptResults;
        if (status) {
          dispatch('flashSuccess', message, { root: true });
        } else {
          dispatch('flashError', error, { root: true });
        }
        return scriptResults;
      } catch (error) {
        dispatch('flashError', 'There was a problem to run script.', { root: true });
        throw error;
      }
    },
    async loadAdditionalScriptRunLog({ commit, dispatch }, { script }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`
          query additionalScriptRunLog($script:String){
            additionalScriptRunLog(script: $script) {
                script,
                county,
                ranAt,
                fromDate,
                toDate,
                flaggedCount,
                clearedCount,
                backupCollection,
                status,
                error
              }
            }
          `,
          variables: { script },
          fetchPolicy: 'no-cache',
        });

        clients.handleGQLErrors(results, commit);
        return results.data.additionalScriptRunLog || [];
      } catch (error) {
        dispatch('flashError', 'There was a problem loading the script run log.', { root: true });
        return [];
      }
    },
  },
  getters: {
    getSelectedCollection: (state) => state.selectedCollection,
    getSelectedScript: (state) => state.selectedScript,
  },
};
export default {};
